// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d71301eb","239":"2b0d3fe7","453":"6a48f306","732":"9ef30785"}[chunkId] + ".chunk.js";
};